import type en from "./en";

export default {
  "dismiss": "capito",

  "appTitle": "Llemma",
  "subtitle": "Vocabolario pre-lettura",
  "inputTipTitle": "📖 Leggi più fluidamente",
  "inputTipBody1": "Incolla il testo che stai per leggere. Llemma individuerà le parole che potresti non ricordare e ti permetterà di ripassarle prima — così puoi leggere con meno interruzioni.",
  "inputTipBody2": "Non troverà tutto, e va bene così. L'obiettivo è una lettura più scorrevole, non la perfezione. Col tempo, Llemma impara quali parole conosci e ti mostra solo quelle che non conosci.",
  "placeholderEsEn": "Incolla il testo in spagnolo qui...",
  "placeholderEnIt": "Incolla il testo in inglese qui...",
  "study": "Studia",

  "quickScan": "Scansione rapida",
  "triageStatus": "{marked} segnate, {unmarked} da studiare",
  "triageHint": "Tocca = ricordo · Pressione lunga / tasto destro = la conosco per sempre",
  "triageTipTitle": "👀 Scansione rapida — non pensarci troppo",
  "triageTipBody": "Scorri queste parole e segna quelle che riconosci a colpo d'occhio.",
  "triageTipTap": "Tocca — la ricordo (saltala per ora, potrebbe tornare dopo)",
  "triageTipRightClick": "Tasto destro / pressione lunga — conosco questa parola benissimo, non mostrarla mai più",
  "triageTipFooter": "Non preoccuparti di essere esaustivo. Se una parola ti sfugge, avrai modo di rivederla nel prossimo passaggio.",
  "prev": "← Prec",
  "next": "Succ →",
  "finish": "Fine",
  "studyN": "Studia {n} parol{eWord}",

  "remaining": "{n} rimanent{eRemaining}",
  "studyTipTitle": "🧠 Ripasso con flashcard",
  "studyTipBody": "Tocca una carta per vedere la definizione, poi valuta quanto bene la conoscevi:",
  "studyTipAgain": "Ripeti — non la sapevo affatto, mostrala di nuovo presto",
  "studyTipHard": "Difficile — ho faticato, mostrala di nuovo presto",
  "studyTipGood": "Bene — la sapevo dopo un attimo di riflessione",
  "studyTipEasy": "Facile — la sapevo subito",
  "studyTipKeyboard": "Tastiera: Spazio/Invio per girare e confermare, o 1-4 per valutare.",
  "noDefinition": "Nessuna definizione disponibile",
  "tapToReveal": "Tocca o premi spazio per rivelare",
  "dismissWord": "Conosco questa parola — non mostrarla mai più",
  "again": "Ripeti",
  "hard": "Difficile",
  "good": "Bene",
  "easy": "Facile",

  "allKnown": "Tutte le parole conosciute!",
  "sessionComplete": "Sessione completata",
  "noWordsNeedReview": "Nessuna parola da ripassare.",
  "reviewedN": "Ripassat{eReviewed} {n} parol{eWord}.",
  "newText": "Nuovo testo",

  "language": "Lingua",
  "studyLanguage": "Lingua di studio",

  "errorLoadingDictionary": "Errore nel caricamento del dizionario",
} as const satisfies Record<keyof typeof en, string>;
